export const BusinessInquiries = () => (
  <span>If you're interested in partnering with us, discussing collaborations, or have any business-related questions, please reach out to our business development team at <a href="mailto:astrologicalstars249@gmail.com">astrologicalstars249@gmail.com</a>.</span>
)